/**
 * @description 用于校验期权填写是否合格的方法
 * 需要满足以下规则: 股票名称 + 空格 + 日期 + 空格 + 行权价(可能是整数或者小数) + 空格 + 期权类型(CALL/PUT)
 */
export function validateOptionSymbol(symbol: string): boolean {
    // 正则表达式解释:
    // ([\w.]+): 匹配股票名称，可以包含字母、数字、下划线和点
    // \s: 匹配空格
    // (\d{8}): 匹配日期，格式为8位数字（YYYYMMDD）
    // (\d+(\.\d+)?): 匹配行权价，可以是整数或小数
    // (CALL|PUT): 匹配期权类型，只能是CALL或PUT
    return /^([\w.]+)\s(\d{8})\s(\d+(\.\d+)?)\s(CALL|PUT)$/.test(symbol);
}
